module.exports = __webpack_public_path__ + "static/img/logo-NC-Core.90dadd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-NC-Core.png
// module id = SC9o
// module chunks = 62